var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20C5.73684 20 5 19.2632 5 18V12C5 10.7368 5.73684 10 7 10H17C18.2632 10 19 10.7368 19 12V18C19 19.2632 18.2632 20 17 20H7ZM7 22H17C19.2456 22 21 20.2456 21 18V12C21 9.75439 19.2456 8 17 8H7C4.75439 8 3 9.75439 3 12V18C3 20.2456 4.75439 22 7 22ZM12 13C10.8947 13 10 13.8947 10 15C10 16.1053 10.8947 17 12 17C13.1053 17 14 16.1053 14 15C14 13.8947 13.1053 13 12 13ZM10 9V6C10 4.73684 10.7368 4 12 4C13.2632 4 14 4.73684 14 6V9H16V6C16 3.75438 14.2456 2 12 2C9.75439 2 8 3.75438 8 6V9H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOutlined);
export default __webpack_public_path__ + "static/media/lock_outlined.3a13f8a5.svg";
export { ForwardRef as ReactComponent };